@if (label()) {
  <div class="flex items-center justify-between" [style.width.rem]="width()">
    <label
      class="mb-x-sm text-sm"
      [class.text-neutral-300]="disabled()"
      [class.cursor-not-allowed]="disabled()"
      [class.text-neutral-900]="!disabled()"
      [class.font-medium]="!disabled()"
      [class.label-required]="requiredEn() || requiredAr()"
      [for]="id()">
      {{ label() }}
    </label>

    <!-- Language Switch -->
    @if (!isSingleInput()) {
      <div class="flex items-center gap-sm lang-switch">
        <button
          type="button"
          class="lang-button"
          [class.active]="currentLang() === 'EN'"
          [class.has-error]="
            childControlEn && childControlEn.touched && childControlEn.errors
          "
          (click)="switchLanguage('EN')">
          EN
        </button>
        <button
          type="button"
          class="lang-button"
          [class.active]="currentLang() === 'AR'"
          [class.me-xl]="isHasToolTip()"
          [class.has-error]="
            childControlAr && childControlAr.touched && childControlAr.errors
          "
          (click)="switchLanguage('AR')">
          AR
        </button>
      </div>
    }
  </div>
}

<div class="flex flex-col">
  <div>
    <!-- English Textarea -->
    <div class="relative flex items-center" [hidden]="currentLang() !== 'EN'">
      @if (startIcon()) {
        <div
          class="icon start-3"
          [class.opacity-30]="disabled()"
          [class.cursor-not-allowed]="disabled()">
          <img [src]="startIcon()" alt="start-icon" />
        </div>
      }

      <textarea
        [id]="id() + '_en'"
        [readOnly]="readonly()"
        [style.width.rem]="width()"
        [style.height.rem]="height()"
        [formControlName]="isSingleInput() ? inputFormControlName() : 'en'"
        [required]="requiredEn()"
        [attr.minlength]="minlength()"
        [attr.maxlength]="maxlength()"
        [placeholder]="displayPlaceholderEn()"
        [rows]="rowsNumber()"
        class="w-full border border-neutral-300 rounded-md shadow-xs text-sm text-neutral-900 p-md"
        [class]="inputClass()"
        [class.has-errors]="
          (childControlEn && childControlEn.touched && childControlEn.errors) ||
          (childControlAr && childControlAr.touched && childControlAr.errors)
        "
        [class.text-destructive-900]="
          childControlEn && childControlEn.touched && childControlEn.errors
        "
        [class.text-neutral-300]="disabled()"
        [class.ps-5xl]="startIcon()"
        [class.pe-5xl]="endIcon()"
        [class.disable-resize]="!canResize()"
        libTrim>
      </textarea>
    </div>

    <!-- Arabic Textarea -->
    @if (!isSingleInput()) {
      <div class="relative flex items-center" [hidden]="currentLang() !== 'AR'">
        @if (startIcon()) {
          <div
            class="icon start-3"
            [class.opacity-30]="disabled()"
            [class.cursor-not-allowed]="disabled()">
            <img [src]="startIcon()" alt="start-icon" />
          </div>
        }

        <textarea
          [id]="id() + '_ar'"
          [readOnly]="readonly()"
          [style.width.rem]="width()"
          [style.height.rem]="height()"
          [formControlName]="'ar'"
          [required]="requiredAr()"
          [attr.minlength]="minlength()"
          [attr.maxlength]="maxlength()"
          [placeholder]="displayPlaceholderAr()"
          [rows]="rowsNumber()"
          class="w-full border border-neutral-300 rounded-md shadow-xs text-sm text-neutral-900 p-md"
          [class]="inputClass()"
          [class.has-errors]="
            childControlAr && childControlAr.touched && childControlAr.errors
          "
          [class.text-destructive-900]="
            childControlAr && childControlAr.touched && childControlAr.errors
          "
          [class.text-neutral-300]="disabled()"
          [class.ps-5xl]="startIcon()"
          [class.pe-5xl]="endIcon()"
          [class.disable-resize]="!canResize()"
          libTrim>
        </textarea>
      </div>
    }
  </div>

  <!-- Validation Messages -->
  <div>
    @if (!isSingleInput()) {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'en'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'ar'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageAr()" />
    } @else {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="inputFormControlName()"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />
    }
  </div>
</div>
